import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f55d78de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-grid" }
const _hoisted_2 = { key: 0 }

import { computed } from 'vue';
import BaseImage from '@/components/ui/BaseImage.vue';

export type Props = {
  images: any[],
  emptyMessage?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageGrid',
  props: {
    images: {},
    emptyMessage: { default: 'No images' }
  },
  setup(__props: any) {

const props = __props;


const isEmpty = computed(() => props.images.length === 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isEmpty.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.emptyMessage), 1))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.images, (image) => {
          return (_openBlock(), _createBlock(BaseImage, {
            key: image.id,
            class: "primary-bg",
            alt: image.altDescription,
            description: image.description,
            url: image.url,
            username: image.username,
            "user-url": image.userUrl
          }, null, 8, ["alt", "description", "url", "username", "user-url"]))
        }), 128))
  ]))
}
}

})